import {createSlice} from '@reduxjs/toolkit';

const loadingReducer = createSlice({
    name: 'loading',
    initialState: 0,
    reducers: {
        startLoading: (state) => state + 1,
        stopLoading: (state) => Math.max(0, state - 1),
    },
});

export const {startLoading, stopLoading} = loadingReducer.actions;
export default loadingReducer.reducer;